export default __webpack_public_path__ + "static/media/dashboard-frame.de0b9b02.png";